import React, { useState } from 'react';

import ChartStockNetBuy from '../../chart/chartStockNetBuy';
import ChartStockForeignBS from '../../chart/chartStockForeignBS';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { numberFormat } from 'utils';

function PanelStockSummary(props) {
  const [tabNNActive, setTabNNActive] = useState('10-phien');
  const { stockDetail, symActive, t, algoSChart } = props;

  return (
    <PerfectScrollbar
      className="mt-2"
      style={{ height: 'calc(100vh - 180px)', marginRight: '-12px' }}
    >
      <div
        className="w-100"
        style={{ paddingRight: '12px', marginTop: '12px' }}
      >
        <p
          className="txt-content font-weight-bold fz-13 mb-2"
          style={{ lineHeight: '14px' }}
        >
          {t('algo.ptcp.txt-Foreigner-trading')}
        </p>
        <div
          className="d-grid"
          style={{ gridTemplateColumns: 'auto auto auto', gap: '10px' }}
        >
          <span className="txt-disabled fz-12">{t('algo.ptcp.txt-Buy-vol')}</span>
          <span className="txt-disabled fz-12">{t('algo.ptcp.txt-Sell-vol')}</span>
          <span className="txt-disabled fz-12">{t('algo.ptcp.txt-Net-buy-vol')}</span>
          <span className="color-up fz-12">
            {numberFormat(stockDetail?.FGBuyQuantity)}
          </span>
          <span className="color-down fz-12">
            {numberFormat(stockDetail?.FGSellQuantity)}
          </span>
          <span
            className={`color-${
              stockDetail?.FGNetQuantity > 0 ? 'up' : 'down'
            } fz-12`}
          >
            {numberFormat(stockDetail?.FGNetQuantity)}
          </span>
          <span className="txt-disabled fz-12">{t('algo.ptcp.txt-Buy-val')}</span>
          <span className="txt-disabled fz-12">{t('algo.ptcp.txt-Sell-val')}</span>
          <span className="txt-disabled fz-12">{t('algo.ptcp.txt-Net-buy-val')}</span>
          <span className="color-up fz-12">
            {numberFormat(stockDetail?.FGBuyValue, 2, '0')} {t('algo.bdkt.txt-bil')}
          </span>
          <span className="color-down fz-12">
            {numberFormat(stockDetail?.FGSellValue, 2, '0')} {t('algo.bdkt.txt-bil')}
          </span>
          <span
            className={`color-${
              stockDetail?.FGNetValue > 0 ? 'up' : 'down'
            } fz-12`}
          >
            {numberFormat(stockDetail?.FGNetValue, 2, '0')} {t('algo.bdkt.txt-bil')}
          </span>
        </div>

        <div className="my-2 d-flex align-items-center">
          <span className="mr-auto txt-disabled fz-12">{t('algo.bdkt.txt-foreigner-buy-val')}</span>
          <div className="btn-gr-nn-muarong">
            <span
              onClick={() => setTabNNActive('Hom-Nay')}
              className={'fz-12 ' + (tabNNActive === 'Hom-Nay' ? 'active' : '')}
            >
              {t('algo.ptcp.txt-intraday')}
            </span>
            <span
              onClick={() => setTabNNActive('10-phien')}
              className={
                'fz-12 ' + (tabNNActive === '10-phien' ? 'active' : '')
              }
            >
              {t('algo.ptcp.txt-10-days')}
            </span>
          </div>
        </div>
        {tabNNActive === '10-phien' && <ChartStockNetBuy symActive={symActive}/>}
        {tabNNActive === 'Hom-Nay' && <ChartStockForeignBS algoSChart={algoSChart} symActive={symActive}/>}
      </div>
    </PerfectScrollbar>
  );
}

export default PanelStockSummary;
